import { render, staticRenderFns } from "./TradingTab.vue?vue&type=template&id=6a0cdf4b&"
import script from "./TradingTab.vue?vue&type=script&lang=js&"
export * from "./TradingTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports